// extracted by mini-css-extract-plugin
export default {"menu":"MenuProducts_menu__Srnyo","title":"MenuProducts_title__YbZ5r"};